import { render, staticRenderFns } from "./DownloadInventory.vue?vue&type=template&id=24f88d70&scoped=true&"
import script from "./DownloadInventory.vue?vue&type=script&lang=js&"
export * from "./DownloadInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f88d70",
  null
  
)

export default component.exports